<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">查询:</div>
                <el-input v-model="conditionData.userId" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">状态:</div>
                <el-select v-model="conditionData.userFileState" size="small" placeholder="请选择">
                    <el-option key="" label="全部"  value=""></el-option>
                    <el-option key="0" label="未审核"  value="0"></el-option>
                    <el-option key="1" label="审核完成"  value="1"></el-option>
                    <el-option key="-1" label="审核不通过"  value="-1"></el-option>
                </el-select>
               
            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="search()">查询</el-button>
                <el-button type="warning" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="primary" icon="el-icon-edit" size="small" @click="updateList()">审核</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                @selection-change="handleSelectionChange"
                style="width: 100%">
                <el-table-column
                type="selection"
                width="80"
                align="center"
                >
                </el-table-column>
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="phone"
                label="手机号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="nickeName"
                label="用户昵称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="userFileState"
                label="音频"
                align="center"
                >
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="isOpen(scope.row)">点击打开</el-button>
                    </template>
                    <!-- <template slot-scope="scope">
                        <audio controls="controls">
                            <source :src="scope.row.accPath" type="audio/mpeg">
                        </audio>
                    </template> -->
                </el-table-column>
                <el-table-column
                prop="userFileState"
                label="审核状态"
                align="center"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.userFileState == 0">待审核</span>
                        <span v-if="scope.row.userFileState == 1" style="color: #67c23a;">审核完成</span>
                        <span v-if="scope.row.userFileState == -1" style="color: #f56c6c;">审核不通过</span>
                    </template>
                </el-table-column>
                <el-table-column
                prop="creationTime"
                label="创建时间"
                align="center"
                >
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="200px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="isAduitDialogOpen(scope.row)">审核</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteDialogOpen(scope.row)">删除</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.current"
                    :page-size="conditionData.size">
                </el-pagination>
            </div>
        </div>


        <el-dialog :close-on-click-modal="false" :visible.sync="isAduitDialog" :title="title" width="400px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        审核状态:
                    </div>
                    <el-select v-model="aduitData.userFileState" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in stateList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                </div>
                
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isAduitDialog = false">取 消</el-button>
                    <el-button type="primary" @click="aduit">确 定</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isAduitListDialog" title="审核" width="400px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        审核状态:
                    </div>
                    <el-select v-model="aduitListData.userFileState" size="small" placeholder="请选择">
                            <el-option
                            v-for="item in stateList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select>
                </div>
                
                <div slot="footer" class="dialog-footer">
                    <el-button @click="isAduitListDialog = false">取 消</el-button>
                    <el-button type="primary" @click="aduitList">确 定</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isOpenDialog" :title="openData.nickeName+'-'+openData.phone" width="400px">
            <div class="dialog">
                <audio controls="controls" ref="audio">
                    <source src="" type="audio/mpeg">
                </audio>
            </div>
        </el-dialog>
        
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
export default {
    name: 'person',
    components:{
        queryCondition,
        forms
    },
    watch: {
    },
    data () {
        return {
           queryList:[
                {
                    type: "input",
                    label: "用户ID:",
                    name: "userId",
                },
                {
                    type: "select",
                    label: "状态:",
                    name: "userFileState",
                },
            ],
            conditionData: {
                userId: "",
                userFileType: 1,
                userFileState: null,
                current:1,
                size:10
            }, 
            stateList:[{
                label:'审核完成',
                value:1,
            },{
                label:'审核不通过',
                value:-1,
            }],
            title:'',
            isShow:false,
            isAddDialog:false,
            isUpdateDialog:false,
            totalCount:0,
            addData:{},
            updateData:{},
            tableData:[
                {
                    filePath:''
                }
            ],
            isAduitDialog:false,
            aduitData:{
                userId:0,
                userFileState:0,
                id:0,
            },
            multipleSelection:[],

            isAduitListDialog:false,
            aduitListData:{},
            openData:{},
            isOpenDialog:false,
        }
    },
    created(){
        

    },
    mounted(){
        this.loadingData();
    },
    methods:{
        isOpen(row){
            this.openData =row;
            this.isOpenDialog = true;
            let _this = this;
            setTimeout(function(){
                _this.$refs.audio.src=row.filePath
            },300)
            this.$forceUpdate();
        },
        isAduitDialogOpen(row){
            this.aduitData.userId = row.userId;
            this.aduitData.userFileState = 1;
            this.aduitData.id = row.id;
            this.title = row.nickeName+'-'+row.phone;
            this.isAduitDialog = true;
        },
        deleteDialogOpen(row){
            this.$confirm('将删除此数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.AdminUserFileDeleteUserFile(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },

        handleSelectionChange(val){
            this.multipleSelection = val;
        },
        updateList(){
            this.isAduitListDialog = true;
            this.aduitListData = {
                userFileState:1
            }
        },
        async aduitList(){
            // let list = [];
            // for(let index in this.multipleSelection){
            //     list.push({
            //         "userId": this.multipleSelection[index].userId,
            //         "state": this.aduitListData.userFileState
            //     });
            // }
            let res  = await api.AdminUserFileUpdateUserFile(this.aduitListData);
            if(res.data.code == '200') {
                this.$message({
                    message: '审核成功',
                    type: 'success'
                });
                this.loadingData();
                this.isAduitListDialog = false;
            }
        },
        async AdminUserFileDeleteUserFile(row){
            let res = await api.AdminUserFileDeleteUserFile([{
                "userId": row.userId,
                "state": row.state
            }]);
            if(res.data.code=='200'){
                this.$message({
                    type: 'success',
                    message: '删除成功'
                }); 
                this.loadingData();
            }
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.AdminUserFileQueryUserFile(this.conditionData);
            this.tableData = res.data.data.records;
            this.totalCount = res.data.data.total;
        },
        search(){
            this.conditionData.current = 1;
            this.loadingData();
        },
        
        reset(){
            this.conditionData = {
                userId: "",
                userFileType: 1,
                userFileState: null,
                current:1,
                size:10,
            },
            this.loadingData();
        },
        handleSizeChange(size){
            this.conditionData.current = 1;
            this.conditionData.size = size;
            this.loadingData();
        },
        handleCurrentChange(page){
            this.conditionData.current = page;
            this.loadingData();
        },
        showAddDialog(){
            this.title = '新增角色';
            this.isShow = true;
            this.isAddDialog = true;
        },
       
        
        
        async aduit(){
            let res  = await api.AdminUserFileUpdateUserFile(this.aduitData);
            if(res.data.code == '200') {
                this.$message({
                    message: '审核成功',
                    type: 'success'
                });
                this.loadingData();
                this.isAduitDialog = false;
            }
        },
        isUpdateDialogShow(row){
            this.title = '编辑角色信息';
            this.isShow = true;
            this.isUpdateDialog = true;
            this.updateData = row;
        }
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            margin-right: 20px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                margin-bottom: 5px;
                margin-right: 10px;
            }
        }
        
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
